import React from 'react';
import { XIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { painPoints } from '../../data/landing';
export function Problem() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-243" data-mp="2roeyzzn0baqv">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.1fr] lg:items-center" data-id="element-244" data-mp="2rn3tnvdwxuxn">
        <div data-id="element-245" data-mp="2moivs2m4vncd">
          <h2 className="text-4xl font-black uppercase leading-[1] tracking-tight text-brand md:text-6xl" data-id="element-246" data-mp="2mp20uiqoqh8z">
            ¿Cuántos domingos más vas a vivir <span className="text-danger" data-id="element-247" data-mp="2cre5prp637qa">con esto?</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-charcoal" data-id="element-248" data-mp="2ct8slbk019x0">
            Tienes colon irritable. Amas comer. Pero nadie te dijo que ibas a pasar los fines de semana con miedo a salir a comer , en los almuerzos evitando ciertos alimentos y llegando a la noche inflamado sin entender por qué.
          </p>
          <p className="mt-6 text-2xl font-extrabold leading-snug text-charcoal" data-id="element-249" data-mp="1z383gi7oeqy">
            No es tu culpa. <Highlight data-id="element-250" data-mp="14b204cfw8dly">Nadie te dio un plan claro… hasta hoy.</Highlight>
          </p>
        </div>

        <div data-id="element-251" data-mp="19a56c07m0pvi">
          <ul className="divide-y divide-danger/15 overflow-hidden rounded-3xl border border-danger/20 bg-danger-soft" data-id="element-252" data-mp="199wvseyylwnh">
            {painPoints.map(p => <li key={p} className="flex items-start gap-4 px-6 py-5" data-id="element-253" data-mp="vc8ax74w6pif">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger" data-id="element-254" data-mp="10a9pberdi0nk">
                  <XIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-255" data-mp="1nzksf2w7474v" />
                </span>
                <span className="text-base font-medium text-charcoal md:text-lg" data-id="element-256" data-mp="1s2qwc3vu5m86">{p}</span>
              </li>)}
          </ul>
          <p className="mt-6 text-center text-xl font-bold italic text-brand md:text-left" data-id="element-257" data-mp="1j7t12q57txdo">
            ¿Y si este fuera el último fin de semana que vives así?
          </p>
        </div>
      </div>
    </section>;
}